import http from '@/utils/http';
import axios from 'axios';

const CancelToken = axios.CancelToken;

export interface IEventClusterRequestParams {
  start_date: string;
  end_date: string;
  game_ids: string[];
  page?: number;
  page_size?: number;
}

export interface IEventClusterItem {
  cluster_id: string;
  game_code: string;
  canonical_title_cn?: string;
  canonical_title_en?: string;
  canonical_description_cn?: string;
  canonical_description_en?: string;
  cover_image_urls?: string[];
  reference_urls?: string[];
  event_date_start?: string;
  event_date_end?: string;
  event_type?: string;
  event_type_cn?: string;
  event_type_code?: string;
  event_type_code_source?: string;
  event_priority?: string;
  major_event?: string;
  major_event_cn?: string;
  countries?: string[];
  member_count?: number;
  source_tables?: string[];
  first_seen_at?: string;
  last_updated_at?: string;
  status?: string;
}

export interface IEventClusterResponse {
  list: IEventClusterItem[];
  total: number;
}

export function fetchEventCluster(
  payload: IEventClusterRequestParams,
  cancelTokenFunc?: (cancel: () => void) => void,
): Promise<IEventClusterResponse> {
  return http({
    url: '/api/v1/intelligence_pc/detail/event_cluster',
    method: 'post',
    data: {
      page: 1,
      page_size: 999999,
      ...payload,
    },
    cancelToken: new CancelToken(cancelTokenFunc || (() => {})),
  }) as Promise<IEventClusterResponse>;
}
